import * as actions from './actions';
import task from '../task';
import taskOverdue from '../task-overdue';
import auditRecord from '../../audit-record-list';

export default {
  namespaced: true,
  state: {
    // 项目详情
    projectDetail: {},
    // 汇总
    projectSummary: {},
    projectSummaryQuery: {}
  },
  mutations: {
    SET_PROJECT_DETAIL(state, { projectDetail }) {
      state.projectDetail = projectDetail;
    },
    SET_PROJECT_SUMMARY(state, { projectSummary }) {
      state.projectSummary = projectSummary;
    },
    SET_PROJECT_SUMMARY_QUERY(state, { query }) {
      state.projectSummaryQuery = query;
    },
    RESET_STATE(state) {
      state.projectDetail = {};
    }
  },
  actions,
  modules: {
    task,
    auditRecord,
    taskOverdue
  }
  // getters
};
